import React from "react"
import history from "../routes/history"
import { COLORS } from "../core/utils"

export default props => {
    let backgroundColor = props.background || COLORS.vermelho
    let icon = props.icon || "navigate_before"
    let color = props.color || "#fff"
    return (
        <button
            style={{ backgroundColor, borderRadius: 5 }}
            onClick={() => history.goBack()}
            className="button is-small btn-back"
        >
            <i className="material-icons " style={{ color, fontSize: 20 }}>
                {icon}
            </i>
        </button>
    )
}
